
export default {
  devStoreConfig: false,
  api: {
    default: 'https://mighty-hamlet-54912.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client1.js